import { createApi } from '@/api/modules/utils'

const baseUrl = '/draft_box/detail'
const api = createApi(baseUrl)

// 用户相关API
export const draftBoxDetailApi = {
  list: api('list', 'get'),
  detail: api('detail', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  search: api('search', 'get'),
  searchConfig: api('search_config', 'get'),
}